import {useMemo} from 'react';
import {compare} from './chooseTubingUtils';

export function useCompatibility(compatibility, design) {
  const {diameter, shrinkRatio, heatshrinkColor} = compatibility ?? {};
  const diameterChoices = useMemo(() => (diameter ? [...diameter].sort(compare) : []), [diameter]);

  const shrinkRatioChoices = useMemo(
    () => (shrinkRatio ? [...shrinkRatio].sort(compare) : []),
    [shrinkRatio]
  );

  const heatshrinkColorChoices = useMemo(
    () => (heatshrinkColor ? [...heatshrinkColor].sort(compare) : []),
    [heatshrinkColor]
  );

  const isCompatible = compatibility?.heatshrinkSelectionIsCompatible ?? false;

  const compatibilityLookup = useMemo(() => {
    if (!compatibility || !design) {
      return {diameter: true, heatshrinkColor: true, shrinkRatio: true};
    }

    const isChoiceCompatible = (type, choices) => {
      const match = choices.find((obj) => obj.value == design[type]);
      return match?.compatible ?? false;
    };

    return {
      diameter: isChoiceCompatible('diameter', diameterChoices),
      heatshrinkColor: isChoiceCompatible('heatshrinkColor', heatshrinkColorChoices),
      shrinkRatio: isChoiceCompatible('shrinkRatio', shrinkRatioChoices)
    };
  }, [design, diameterChoices, heatshrinkColorChoices, shrinkRatioChoices, compatibility]);

  return {
    diameterChoices,
    shrinkRatioChoices,
    heatshrinkColorChoices,
    isCompatible,
    compatibilityLookup
  };
}
